import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { DISPLAY_DATE_FORMAT } from '../../../app.constants';
import { Label, SingleDataSet } from 'ng2-charts';
import { ChartOptions, ChartType } from 'chart.js';
import { HomeGraphData } from '../../home.model';

@Component({
  selector: 'iaud-sid-graph',
  templateUrl: './sid-graph.component.html',
  styleUrls: ['./sid-graph.component.scss'],
})
export class SidGraphComponent implements OnInit {
  dateFormat = DISPLAY_DATE_FORMAT;
  date = new Date();
  @Input()
  refreshCallback: EventEmitter<boolean>;

  public sidLabels: Array<Label> =
    ['Completed', 'Approved', 'Returned', 'Rejected', 'Evidence Approval',
     'Evidence Submission', 'Pending 2nd Approval', 'Pending 1st Approval', 'Ready To Submit', 'Draft'];
  public capaLabels: Array<Label> =
    ['Completed', 'Approved', 'Returned', 'Pending Approval', 'Pending Evidence', 'Ready To Submit', 'Draft'];
  public sidData: SingleDataSet = [4, 5, 2, 5, 7, 4, 9, 7, 4, 9];
  public capaData: SingleDataSet = [4, 3, 6, 2, 1, 4, 8];

  public doughnutChartType: ChartType = 'doughnut';

  sidOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: true,
  };
  capaOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: true,
  };

  @Input()
  data: HomeGraphData;

  // @ViewChild('sidGraph') sidGraph: ElementRef;
  // @ViewChild('capaGraph') capaGraph: ElementRef;
  constructor() { }

  ngOnInit() {
    // const sidCtx = this.sidGraph.nativeElement.getContext('2d');
    // const me = this;
    // this.sidOptions = {
    //   responsive: true,
    //   maintainAspectRatio: true,
    //   animation: {
    //     onProgress: function () {
    //       me.doIt(sidCtx, me.sidGraph, 'SIDs', 10);
    //     },
    //     onComplete: function () {
    //       me.doIt(sidCtx, me.sidGraph, 'SIDs', 10);
    //     }
    //   }
    // }
    // const capaCtx = this.capaGraph.nativeElement.getContext('2d');

    // this.capaOptions = {
    //   responsive: true,
    //   maintainAspectRatio: true,
    //   animation: {
    //     onProgress: function () {
    //       me.doIt(capaCtx, me.capaGraph, 'CAPA/ECs', 5);
    //     },
    //     onComplete: function () {
    //       me.doIt(capaCtx, me.capaGraph, 'CAPA/ECs', 5);
    //     }
    //   }
    // }
  }

  // doIt(ctx, canvas, text, count): void {
  //   const width = canvas.nativeElement.clientWidth;
  //   const height = canvas.nativeElement.clientHeight;

  //   const fontSize = (height / 250);
  //   const pxSize = fontSize * 12;
  //   ctx.font = fontSize.toFixed(2) + "em Verdana";
  //   ctx.fillStyle = "black";

  //   const textX = Math.round((width - ctx.measureText(text).width) / 2);
  //   const textY = height / 2;

  //   ctx.textBaseline = "bottom";
  //   ctx.moveTo(textX, 0);
  //   ctx.lineTo(textX, width);

  //   ctx.fillText(text, textX, textY);
  //   ctx.textBaseline = "top";
  //   ctx.fillText(count, Math.round((width - ctx.measureText(count).width) / 2), textY);
  //   ctx.restore();
  // }

  // // events
  // public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
  //   console.log(event, active);
  // }

  // public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
  //   console.log(event, active);
  // }

  count(data: Array<number>): number {
    return data.reduce((x, y) => x + y, 0);
  }
  refresh() {
    this.refreshCallback.emit(true);
  }
}
